import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import './css/ListingFilters.css';

const ListingFilters = ({ isOpen, closeFilter, updateHist, updatePrice, updateMile, hist, price, mile }) => {
  return (
    <div className={`sidebar ${isOpen ? 'show' : ''}`}>
      <div onClick={closeFilter} className="sidebar-btn">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" style={{display:"block"}}>
          <rect x="4" y="11" width="16" height="2" fill="currentColor" rx="1" />
        </svg>
      </div>
      <h3>Filter Vehicles</h3>
      <div className="filter-group">
        <h4>Structural Condition</h4>
        <label><input type="checkbox" checked={hist === 1} onChange={() => updateHist(1)}/> Non-Accident</label>
        <label><input type="checkbox" checked={hist === 2} onChange={() => updateHist(2)}/> Minor Accident History</label>
        <label><input type="checkbox" checked={hist === 3} onChange={() => updateHist(3)}/> Medium Accident History</label>
        <label><input type="checkbox" checked={hist === 4} onChange={() => updateHist(4)}/> Major Structural Repair History</label>
      </div>
      <div className="filter-group">
        <h4>Price</h4>
        <label><input type="checkbox" checked={price === 1} onChange={() => updatePrice(1)}/> Below RM50,000</label>
        <label><input type="checkbox" checked={price === 2} onChange={() => updatePrice(2)}/> RM50,000 - RM100,000</label>
        <label><input type="checkbox" checked={price === 3} onChange={() => updatePrice(3)}/> RM100,000 - RM150,000</label>
        <label><input type="checkbox" checked={price === 4} onChange={() => updatePrice(4)}/> Above RM150,000</label>
      </div>
      <div className="filter-group">
        <h4>Mileage</h4>
        <label><input type="checkbox" checked={mile === 1} onChange={() => updateMile(1)}/> Below 50,000 KM</label>
        <label><input type="checkbox" checked={mile === 2} onChange={() => updateMile(2)}/> 50,000 - 100,000 KM</label>
        <label><input type="checkbox" checked={mile === 3} onChange={() => updateMile(3)}/> Above 100,000 KM</label>
      </div>
    </div>
  );
};

export default ListingFilters;